import React, { Component } from "react";
import { FormGroup, Label, Button, Input, Row, Col } from "reactstrap";
import { AppSwitch } from "@coreui/react";
import ReactMultiSelectCheckboxes from "react-multiselect-checkboxes";

import Select from "react-select";
class serviceInformation extends Component {
  render() {
    const {
      serviceSubmitHandler,
      changeHandler,
      listOfServices,
      handleClick,
      isServiceLoading,
      serviceChangeHandler,
      selectedServices
    } = this.props;
    return (
      <form className="serviceForm" onSubmit={(e)=>serviceSubmitHandler(e)}>
        <div className="row">
          <div className="mt-2" onClick={() => changeHandler("2")}>
            <span style={{ color: "#174C8B", fontSize: "13px" }}>
              <i className="bi bi-arrow-left-short ml-2" />
            </span>
            <span
              className="ml-1"
              style={{
                color: "#174C8B",
                fontSize: "13px",
                cursor: "pointer",
              }}
            >
              Back
            </span>
          </div>
        </div>
        <div className="row">
          {/* <div className="mt-2">
            <span style={{ color: "#174C8B", fontSize: "13px" }}>🡸</span>
            <span
              style={{
                color: "#174C8B",
                fontFamily: "Montserrat",
                fontSize: "13px",
                cursor:"pointer"
                
              }}
            >
              Back
            </span>
          </div> */}

          <div className="col-md-12 ml-lg-3 ml-3">
            <div className="text-secondary mb-2 mt-3">
              <span
                style={{
                  color: "#083E95",
                  fontSize: "15px",
                  fontWeight: "600",
                }}
              >
                Select Service(s) & Modes
              </span>
            </div>
            <div className="row mb-5 mt-3">
              <div className="col-12">
                <ReactMultiSelectCheckboxes
                  options={listOfServices}
                  onChange={(e) => serviceChangeHandler(e)}
                  value={selectedServices}
                />
                <small className="text-primary pl-1">
                  You can choose multiple Services in one go
                </small>
              </div>
            </div>
            {selectedServices.length > 0 && (
              <div className="mb-2 ml-1">Selected Service(s)</div>
            )}
            {selectedServices.map((ele, index) => (
              <div className="selctOptionStyle mb-4 mr-4 rounded">
                <span className="d-inline-block text-primary">
                  {index + 1}.
                </span>
                <span className="lbelName text-primary">{ele.label}</span>
                <p className="line"></p>
                <div className="selectModes mt-2">
                  <FormGroup check inline>
                    <Label className="selService my-auto mr-lg-3 d-lg-block d-none">
                      Select Mode(s)
                    </Label>
                    <Input
                      type="checkbox"
                      onClick={() => handleClick(index, "Online")}
                      className="checkbox-circle onlineBack"
                      style={{ border: "2px solid #8CE5BB" }}
                    />
                    <Label className="selService" check>
                      Online
                    </Label>
                  </FormGroup>
                  <FormGroup check inline>
                    <Input
                      type="checkbox"
                      onClick={() => handleClick(index, "Home")}
                      className="checkbox-circle homeBack"
                      style={{ border: "2px solid #FFB300" }}
                    />
                    <Label className="selService" check>
                      Home
                    </Label>
                  </FormGroup>
                  <FormGroup check inline>
                    <Input
                      type="checkbox"
                      onClick={() => handleClick(index, "Center")}
                      className="checkbox-circle centerBack"
                      style={{ border: "2px solid #E96A4F" }}
                    />
                    <Label className="selService" check>
                      Center
                    </Label>
                  </FormGroup>
                </div>
              </div>
            ))}
            {/* {data.map((a, index) =>
              a.isServiceSelected === true ? (
                <div className="selctOptionStyle mt-5">
                  <span>{no}</span>
                  <span className="lbelName">{a.label}</span>
                  <div className="lineFade"></div>
                  <div className="selectModes mt-1">
                    <FormGroup check inline>
                      <Input
                        type="checkbox"
                        onClick={() => handleClick(index, "Online")}
                      />
                      <Label className="selService" check>
                        Online
                      </Label>
                    </FormGroup>
                    <FormGroup check inline>
                      <Input
                        type="checkbox"
                        onClick={() => handleClick(index, "Home")}
                      />
                      <Label className="selService" check>
                        Home
                      </Label>
                    </FormGroup>
                    <FormGroup check inline>
                      <Input
                        type="checkbox"
                        onClick={() => handleClick(index, "Center")}
                      />
                      <Label className="selService" check>
                        Center
                      </Label>
                    </FormGroup>
                  </div>
                </div>
              ) : (
                ""
              )
            )} */}

            {/* {data.map((a)=>(a.value))} */}

            {/* {listOfServices.map((row, id) => {
              if (row.isServiceSelected === "0") {
                <h1>No</h1>;
              }
              else{
                <h1>Vishwas</h1>
              }
            })} */}

            {/* Button */}
          </div>
          {isServiceLoading === true ? (
            <Row>
              <Col className="d-flex justify-content-center p-2">
                <Button
                  type="submit"
                  color="warning"
                  style={{ color: "#fff" }}
                  className="px-5"
                >
                  <span class="spinner-border spinner-border-sm" />
                  Submit
                </Button>
              </Col>
            </Row>
          ) : (
            <Row>
              <Col className="d-flex justify-content-center p-2">
                <Button
                  type="submit"
                  color="warning"
                  style={{ color: "#fff" }}
                  className="px-5"
                >
                  <span className='bi bi-hand-index-fill mr-1'></span>
                  Submit
                </Button>
              </Col>
            </Row>
          )}
        </div>
      </form>
    );
  }
}

export default serviceInformation;
